// Jodi (project codename) — two-sided AI hiring marketplace (prototype).
// Every product name lives here so the brand can change in one place.
// The display names are working names, not decisions; code, routes and tokens keep "jodi".

export const JODI_BASE = '/jodi';

export const BRAND = {
  product: 'Karan Arjun',
  // Candidate-side agent (our "Jack")
  talentAgent: 'Arjun',
  // Company-side agent (our "Jill")
  hireAgent: 'Karan',
};

export const jodiPath = (sub = '') => (sub ? `${JODI_BASE}/${sub}` : JODI_BASE);
